<div>
    <app-loading-spinner></app-loading-spinner>
    <app-analytics></app-analytics>
    <router-outlet></router-outlet>
    <app-modal></app-modal>
    <app-jitsi-meet class="jitsi-meet"></app-jitsi-meet>
</div>
